import Image from 'next/image'

import { Text } from '@wartek-id/text-v1'

export function KinerjaHarianEmptyState() {
  return (
    <article className="flex flex-col items-center justify-center bg-white py-20 text-center space-y-1">
      <div className="mb-2">
        <Image
          alt=""
          src="/illustrations/img-empty-document-2.png"
          width={90}
          height={90}
        />
      </div>

      <Text as="h2" variant="body-sm">
        Mari mulai catat Kinerja Harian Anda
      </Text>

      <Text
        color="subdued"
        variant="body-sm"
        className="max-w-[360px] leading-6"
      >
        Tanggal yang dicatat nanti akan muncul di daftar ini.
      </Text>
    </article>
  )
}
